module.exports = __webpack_public_path__ + "img/youtube.f311a1bd.svg";